import type { ReactNode } from "react";

export default function Shell({ children }: { children: ReactNode }) {
  return <div className="container">{children}</div>;
}
